import "./App.css";
import AppRouter from "./routers/AppRouter";
import Layout from "./components/Layout/index";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { createRtlCache } from "./utils/rtlCache";
function App() {
  const { i18n } = useTranslation();
  const isRtl = i18n.language === "ae";

  useEffect(()=>{
    document.body.dir=isRtl?'rtl':'ltr'
  },[isRtl]);
  const cache=useMemo(()=>createRtlCache(isRtl),[isRtl]);
  const theme = useMemo(
    () =>
      createTheme({
        direction: isRtl ? "rtl" : "ltr",
      }),
    [isRtl]
  );

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
    <div className="App">
      <Layout>
        <AppRouter />
      </Layout>
    </div>
    </ThemeProvider>
    </CacheProvider>
  );
}

export default App;
